import mappedItemTypes from 'services/items/mappedItemTypes';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import { PCW_STEPS } from '../constants';

export function GlobalShapesStep() {
    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_GLOBAL_SHAPES_STEP_ID}
            itemTypeIds={[mappedItemTypes.SHAPE_SETS.id]}
        />
    );
}
